<template>
  <div id="creek-content-page-container">
    <div v-if="!html" v-html="Creek.config.shows.router.loadingHTML"></div>
    <div class="creek-page-content" v-if="API.Broadcast">
      <h1 v-text="API.Broadcast.title"></h1>
      <div class="creek-page-content-text" v-text="API.Broadcast.text"></div>
      <creek-audio-player broadcast-id="$route.params.broadcastID"></creek-audio-player>
      <creek-playlist></creek-playlist>
    </div>
  </div>
</template>

<script type="text/javascript">

import mixins from '../util/mixins';
import JSONP from 'jsonp';

export default {
  name: 'creek-page-broadcast',
  mixins: [mixins.routes],
  data () { 
    return { 
      API: {
        Broadcast: {}
      }
    } 
  },
  created () {
    this.fetchData();
  },
  methods: {
    fetchData () {

      var URL = this.Creek.config.content.baseURLForAPI 
        + "/broadcasts/" 
        + this.$route.params.broadcastID;

      this.Creek.debug.log("Loading Vue.js route from API: " + URL);

      var _this = this;

      JSONP(URL, null, function(err, data) {
        _this.setTitle(data.title);
        _this.swapPageClass("broadcast");
        _this.API.Broadcast = data;
      })

    }
  }
}
</script>